/**
 * Jeu d'essai : monte une élection complète et prête à voter en un clic.
 * Sert à la prévisualisation et aux démonstrations, jamais en conditions réelles.
 */

import { DEFAULT_RULES, parseRoster } from '../core/index.js';
import { store } from './store.js';

const LISTE = `Alice Dupont
Bruno Martin
Chloé Bernard
David Petit
Emma Rousseau
Farid Benali
Gaëlle Moreau
Hugo Lefèvre
Inès Garnier
Jules Faure`;

/**
 * Crée une élection de démonstration : dix élèves, trois binômes déclarés,
 * les quatre autres votables seuls, dix codes générés, premier tour ouvert.
 */
export async function chargerExemple(): Promise<string> {
  const electionId = await store.create({
    nom: 'Délégués — exemple',
    classe: '2nde A',
    etablissement: 'Lycée de démonstration',
    dateISO: new Date().toISOString().slice(0, 10),
    rules: DEFAULT_RULES,
  });

  await store.importRoster(parseRoster(LISTE).persons);
  await store.generateCodes(10);

  await store.declare('p_1', 'p_2');
  await store.declare('p_3', 'p_4');
  await store.declare('p_5', 'p_6');

  await store.setPhase('CANDIDATURES');
  await store.setPhase('VALIDATION');
  await store.setPhase('TOUR1');

  return electionId;
}
